import {
  PackageSummaryActions,
  EPackageSummaryActions
} from '../actions/package-visualizer.actions';

const initialPackageVisualizerState: IPackageVisualizerState = {
  isLoading: false,
  summaryTree: null,
  selectedCatalogObjectsByType: null,
  navigation: [],
  filterParameters: null,
  packageDependencies: null,
  selectedPackageId: null,
  hasError: false
};

export function PackageVisualizerReducer(
  state = initialPackageVisualizerState,
  action: PackageSummaryActions
): IPackageVisualizerState {
  switch (action.type) {
    case EPackageSummaryActions.GetPackageSummary: {
      const newState: IPackageVisualizerState = {
        ...state,
        isLoading: true,
        selectedPackageId: action.payload.packageId.toString(),
        summaryTree: null,
        navigation: [],
        selectedCatalogObjectsByType: null
      };
      return newState;
    }

    case EPackageSummaryActions.GetPackageSummarySuccess: {
      const newState: IPackageVisualizerState = {
        ...state,
        summaryTree: _.cloneDeep(action.payload)
      };
      return newState;
    }

    case EPackageSummaryActions.SetError: {
      return {
        ...state,
        hasError: _.cloneDeep(action.payload)
      };
    }

    case EPackageSummaryActions.SetSelectedCatalogObjects: {
      if (!state.summaryTree) {
        return state;
      }
      const parentId = action.payload
        ? action.payload
        : state.summaryTree.workspace.id;
      const selectedObjects: Array<{
        type: string;
        objectList: ICatalogObject[];
      }> = [];
      const typesIndex: { [key: string]: number } = {};
      Object.keys(state.summaryTree.objects).forEach(objectId => {
        if (parentId === state.summaryTree.objects[objectId].parentId || parentId === state.summaryTree.objects[objectId].parentTreeId) {
          const catalogObj: ICatalogObject = _.cloneDeep(
            state.summaryTree.objects[objectId]
          );
          if (typeof typesIndex[catalogObj.type] === 'undefined') {
            typesIndex[catalogObj.type] = selectedObjects.length;
          }
          const idx = typesIndex[catalogObj.type];
          selectedObjects[idx] = {
            type: catalogObj.type,
            objectList: selectedObjects[idx]
              ? _.orderBy([...selectedObjects[idx].objectList, catalogObj], (o) => o.name.toLowerCase())
              : [catalogObj]
          };
        }
      });
      if (selectedObjects.length === 0 && action.payload) {
        return state;
      }
      const navigation: IPackageNavigation[] = [...state.navigation];
      const newNavigation: IPackageNavigation[] = [];
      if (navigation.length > 0) {
        let isPrevious = false;
        for (let k = 0; k < navigation.length; k++) {
          newNavigation[k] = navigation[k];
          if (newNavigation[k].catalogObjectId === parentId) {
            isPrevious = true;
            break;
          }
        }
        if (action.payload && !isPrevious && selectedObjects.length > 0) {
          newNavigation.push({
            displayName:
              state.summaryTree.objects[action.payload].id !==
                state.summaryTree.workspace.id
                ? state.summaryTree.objects[action.payload].name
                : 'DEPLOYMENT.OBJECT_CONTENT',
            catalogObjectId: state.summaryTree.objects[action.payload].id
          });
        }
      } else {
        newNavigation.push({
          displayName: 'DEPLOYMENT.OBJECT_CONTENT',
          catalogObjectId: state.summaryTree.objects[parentId].id
        });
      }
      const newState: IPackageVisualizerState = {
        ...state,
        isLoading: false,
        navigation: newNavigation,
        selectedCatalogObjectsByType: _.orderBy(selectedObjects, (o) => o.type.toLowerCase())
      };
      return newState;
    }

    case EPackageSummaryActions.SearchAndFilterPackageSummary: {
      if (!state.summaryTree) {
        return state;
      }

      const selectedObjects: Array<{
        type: string;
        objectList: ICatalogObject[];
      }> = [];

      const typesIndex: { [key: string]: number } = {};
      Object.keys(state.summaryTree.objects).forEach(objectId => {
        if (
          ((state.summaryTree.objects[objectId].name &&
            state.summaryTree.objects[objectId].name
              .toUpperCase()
              .indexOf(state.filterParameters.searchText.toUpperCase()) !==
              -1) ||
            (state.summaryTree.objects[objectId].modifiedByUser &&
              state.summaryTree.objects[objectId].modifiedByUser
                .toUpperCase()
                .indexOf(state.filterParameters.searchText.toUpperCase()) !==
                -1)) &&
          (!state.filterParameters.selectedFilters ||
            state.filterParameters.selectedFilters.length === 0 ||
            (state.summaryTree.objects[objectId].type &&
              _.find(state.filterParameters.selectedFilters, o =>
                state.summaryTree.objects[objectId].type.match(o)
              )))
        ) {
          const catalogObj: ICatalogObject = _.cloneDeep(
            state.summaryTree.objects[objectId]
          );
          if (typeof typesIndex[catalogObj.type] === 'undefined') {
            typesIndex[catalogObj.type] = selectedObjects.length;
          }
          const idx = typesIndex[catalogObj.type];
          selectedObjects[idx] = {
            type: catalogObj.type,
            objectList: selectedObjects[idx]
              ? _.orderBy([...selectedObjects[idx].objectList, catalogObj], o =>
                  o.name.toLowerCase()
                )
              : [catalogObj]
          };
        }
      });

      const newState: IPackageVisualizerState = {
        ...state,
        selectedCatalogObjectsByType: _.orderBy(selectedObjects, (o) => o.type.toLowerCase()),
      };
      return newState;
    }

    case EPackageSummaryActions.SetSearchText: {
      const newState: IPackageVisualizerState = {
        ...state,
        filterParameters: {
          ...state.filterParameters,
          searchText: _.cloneDeep(action.payload),
        }
      };
      return newState;
    }

    case EPackageSummaryActions.SetSelectedFilters: {
      const newState: IPackageVisualizerState = {
        ...state,
        filterParameters: {
          ...state.filterParameters,
          selectedFilters: _.cloneDeep(action.payload),
        }
      };
      return newState;
    }

    case EPackageSummaryActions.GetDependencies: {
      const newState: IPackageVisualizerState = {
        ...state,
        isLoading: true
      };
      return newState;
    }

    case EPackageSummaryActions.GetDependenciesSuccess: {
      const newState: IPackageVisualizerState = {
        ...state,
        isLoading: false,
        packageDependencies: _.cloneDeep(action.payload)
      };
      return newState;
    }

    default:
      return state;
  }
}
